import {toAbsoluteUrl} from '_metronic/helpers'
import {FrameworkDataType} from '../components/Compliance'
import {FC} from 'react'

type Props = {
  frameworks: FrameworkDataType[]
}

const ComplianceTab: FC<Props> = ({frameworks}) => {
  return (
    <div>
      {frameworks.length > 0 ? (
        <div
          className='w-100 d-grid'
          style={{
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '16px',
          }}
        >
          {frameworks?.map((framework, index) => (
            <div
              key={index}
              className='d-flex flex-column align-items-center bg-white'
              style={{
                border: '1px solid #E5E7EB',
                borderRadius: '8px',
                gap: '12px',
                padding: '24px 16px',
              }}
            >
              <img
                alt={`${framework.title}-logo`}
                src={toAbsoluteUrl(framework.logoURL as string)}
                className='object-fit-cover'
                style={{height: '80px', width: '80px'}}
              />

              <span className='fw-medium text-custom-primary-gray text-center' style={{fontSize: '16px'}}>
                {framework.title}
              </span>

              <div
                className='mt-auto d-flex align-items-center px-2'
                style={{
                  backgroundColor: `${framework.status === 'Compliant' ? '#DEF7EC' : '#FEECDC'}`,
                  border: `${
                    framework.status === 'Compliant' ? '1px solid #BCF0DA' : '1px solid #FCD9BD'
                  }`,
                  borderRadius: '6px',
                  paddingBlock: '2px',
                }}
              >
                <img
                  alt={`${framework.title}-logo`}
                  src={`${
                    framework.status === 'Compliant'
                      ? toAbsoluteUrl('/media/icon/circle-check.svg')
                      : toAbsoluteUrl('/media/icon/loader.svg')
                  }`}
                  className=''
                  style={{height: '14px', width: '14px'}}
                />
                <span
                  className='fw-medium fs-8 fs-sm-6 ms-1 text-center'
                  style={{
                    color: `${framework.status === 'Compliant' ? '#03543F' : '#8A2C0D'}`,
                  }}
                >
                  {framework.status}
                </span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div
          className='w-100 h-100 d-flex align-items-center justify-content-center'
          style={{border: '1px solid #D1D5DB', borderRadius: '8px', paddingBlock: '24px'}}
        >
          <span className='text-custom-primary-gray fw-medium' style={{fontSize: '16px'}}>
            No frameworks added
          </span>
        </div>
      )}
    </div>
  )
}

export default ComplianceTab
